import { extendObservable, runInAction } from 'mobx';

import { PasswordConfirmationController } from '../networking/controllers/PasswordConfirmationController';
import { Logger } from '../helpers/Logger';
import { ERROR_STATUSES } from '../models/ApiError';

class PasswordConfirmationStoreClass {
  constructor() {
    extendObservable(this, {
      modalEnabled: false,
      loadingConfirmation: false,
      confirmationError: false,
      passwordIncorrect: false,
    });
    this.callback = null;
    this.resolvePromise = null;
    this.rejectPromise = null;
  }

  showConfirmationModal(callback) {
    if (typeof callback === 'function') {
      this.callback = callback;
    } else {
      this.callback = null;
    }
    runInAction(() => {
      this.modalEnabled = true;
    });
    return new Promise((resolve, reject) => {
      this.resolvePromise = resolve;
      this.rejectPromise = reject;
    });
  }

  _clearPromiseData() {
    this.resolvePromise = null;
    this.rejectPromise = null;
  }

  _closeModal() {
    runInAction(() => {
      this.modalEnabled = false;
    });
  }

  cancelConfirmation() {
    this._closeModal();
    if (this.rejectPromise) {
      this.rejectPromise(new Error('Password validation has been cancelled.'));
    }
  }

  async confirmPassword(password) {
    runInAction(() => {
      this.loadingConfirmation = true;
      this.confirmationError = false;
      this.passwordIncorrect = false;
    });
    try {
      await PasswordConfirmationController.confirm(password);
      this._closeModal();
      if (this.callback) {
        const result = await this.callback();
        if (this.resolvePromise) {
          this.resolvePromise(result);
        }
      }
    } catch (error) {
      Logger.warn(error);
      if (error.response && error.response.status === ERROR_STATUSES.UNAUTHORIZED) {
        runInAction(() => {
          this.passwordIncorrect = true;
        });
      } else {
        runInAction(() => {
          this.confirmationError = true;
        });
      }
    } finally {
      runInAction(() => {
        this.loadingConfirmation = false;
      });
    }
  }
}

const PasswordConfirmationStore = new PasswordConfirmationStoreClass();

export { PasswordConfirmationStore };



// WEBPACK FOOTER //
// ./src/stores/PasswordConfirmationStore.js